import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75118be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-portfolio" }
const _hoisted_2 = {
  key: 0,
  class: "portfolio-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading products...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "portfolio-error"
}
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "section-description"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "divider-line" }),
  /*#__PURE__*/_createElementVNode("span", { class: "divider-text" }, "Products"),
  /*#__PURE__*/_createElementVNode("span", { class: "divider-line" })
], -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "project-header" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "project-icon"
}
const _hoisted_15 = { class: "project-info" }
const _hoisted_16 = { class: "project-title" }
const _hoisted_17 = { class: "project-tagline" }
const _hoisted_18 = { class: "project-description" }
const _hoisted_19 = { class: "screenshot-area" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "placeholder-box placeholder-screenshot"
}
const _hoisted_22 = {
  key: 0,
  class: "topics-section"
}
const _hoisted_23 = { class: "topic-tags" }
const _hoisted_24 = { class: "project-header" }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "project-icon"
}
const _hoisted_27 = { class: "project-info" }
const _hoisted_28 = { class: "project-title" }
const _hoisted_29 = { class: "project-tagline" }
const _hoisted_30 = { class: "project-description" }
const _hoisted_31 = { class: "screenshot-area" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "placeholder-box placeholder-screenshot"
}
const _hoisted_34 = {
  key: 0,
  class: "topics-section"
}
const _hoisted_35 = { class: "topic-tags" }
const _hoisted_36 = {
  key: 1,
  class: "services-section"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "divider-line" }),
  /*#__PURE__*/_createElementVNode("span", { class: "divider-text" }, "Services"),
  /*#__PURE__*/_createElementVNode("span", { class: "divider-line" })
], -1))
const _hoisted_38 = { class: "project-header" }
const _hoisted_39 = { class: "project-icon service-icon" }
const _hoisted_40 = { class: "project-info" }
const _hoisted_41 = { class: "project-title" }
const _hoisted_42 = { class: "project-tagline" }
const _hoisted_43 = { class: "project-description" }
const _hoisted_44 = {
  key: 0,
  class: "topics-section"
}
const _hoisted_45 = { class: "topic-tags" }
const _hoisted_46 = {
  key: 3,
  class: "portfolio-footer-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, {
                name: "code-slash-outline",
                class: "error-icon"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.sectionDescription)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.sectionDescription), 1))
              : _createCommentVNode("", true),
            _hoisted_10,
            _createVNode(_TransitionGroup, {
              name: "project-list",
              tag: "div",
              class: "portfolio-grid"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.id,
                    class: "portfolio-card"
                  }, [
                    (product.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: product.url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "product-link"
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            (product.logo)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: product.logo,
                                  class: "header-logo",
                                  alt: "Logo"
                                }, null, 8, _hoisted_13))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.getIcon(product.icon)
                                  }, null, 8, ["icon"])
                                ])),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("h3", _hoisted_16, _toDisplayString(product.name), 1),
                              _createElementVNode("p", _hoisted_17, _toDisplayString(product.tagline), 1)
                            ]),
                            _createElementVNode("span", {
                              class: "status-badge",
                              style: _normalizeStyle(_ctx.statusBadgeStyle(product.statusColor))
                            }, _toDisplayString(product.status), 5)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("p", null, _toDisplayString(product.description), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (product.screenshot)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: product.screenshot,
                                  class: "product-screenshot",
                                  alt: "Screenshot"
                                }, null, 8, _hoisted_20))
                              : (_openBlock(), _createElementBlock("div", _hoisted_21, "Screenshot"))
                          ]),
                          (product.topics && product.topics.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.topics, (topic) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: topic,
                                      class: "topic-tag"
                                    }, _toDisplayString(topic), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_11))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_24, [
                            (product.logo)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: product.logo,
                                  class: "header-logo",
                                  alt: "Logo"
                                }, null, 8, _hoisted_25))
                              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.getIcon(product.icon)
                                  }, null, 8, ["icon"])
                                ])),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("h3", _hoisted_28, _toDisplayString(product.name), 1),
                              _createElementVNode("p", _hoisted_29, _toDisplayString(product.tagline), 1)
                            ]),
                            _createElementVNode("span", {
                              class: "status-badge",
                              style: _normalizeStyle(_ctx.statusBadgeStyle(product.statusColor))
                            }, _toDisplayString(product.status), 5)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("p", null, _toDisplayString(product.description), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            (product.screenshot)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: product.screenshot,
                                  class: "product-screenshot",
                                  alt: "Screenshot"
                                }, null, 8, _hoisted_32))
                              : (_openBlock(), _createElementBlock("div", _hoisted_33, "Screenshot"))
                          ]),
                          (product.topics && product.topics.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.topics, (topic) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: topic,
                                      class: "topic-tag"
                                    }, _toDisplayString(topic), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            (_ctx.services.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(_TransitionGroup, {
                    name: "project-list",
                    tag: "div",
                    class: "portfolio-grid"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: service.id,
                          class: "portfolio-card service-card"
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.getIcon(service.icon)
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("h3", _hoisted_41, _toDisplayString(service.name), 1),
                              _createElementVNode("p", _hoisted_42, _toDisplayString(service.tagline), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", null, _toDisplayString(service.description), 1)
                          ]),
                          (service.topics && service.topics.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.topics, (topic) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: topic,
                                      class: "topic-tag"
                                    }, _toDisplayString(topic), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46))
      : _createCommentVNode("", true)
  ]))
}